// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoChartBarOutlinedSvg from "@fishx/icons-svg/es/asn/PtoChartBarOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoChartBarOutlined = function PtoChartBarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoChartBarOutlinedSvg
  }));
};

PtoChartBarOutlined.displayName = 'PtoChartBarOutlined';
export default React.forwardRef(PtoChartBarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoChartBarOutlined.js
// module id = 3875
// module chunks = 0